import dayjs from 'dayjs';

export class GamePeriodModel {

  /**
   * Constructor
   *
   * @param number [the gameperiod number]
   * @param start_at [the datetime when the gameperiod starts]
   * @param end_at [the datetime when the gameperiod ends]
   * @param wave_nr [the wave number of the gameperiod]
   * @param wave_type [the wave type fo the gameperiod]
   * @param week [the week number of the gameperiod]
   * @param from [the localized date string when the gameperiod starts]
   * @param to [the localized date string when the gameperiod ends]
   * @param time_left [amount of seconds left until the gameperiod ends]
   * @param game_started [boolean if the game has started, used by the active gameperiod]
   * @param game_ended [boolean if the game has ended, used by the active gameperiod]
   * @param iHash [string]
   */
  public constructor(
    public number: number = null,
    public start_at: string|dayjs.Dayjs = null,
    public end_at: string|dayjs.Dayjs = null,
    public wave_nr: number = null,
    public wave_type: string = null,
    public week: number = null,
    public from: string = null,
    public to: string = null,
    public time_left: number = null,
    public game_started: boolean = false,
    public game_ended: boolean = false,
    public iHash: string = null,
  ) {
    this.start_at = dayjs(this.start_at);
    this.end_at = dayjs(this.end_at);
  }
}
